import { Link } from 'react-router-dom';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';

export default function CartPage() {
  const { items, updateQty, removeItem, subtotal, bundleDiscount, shipping, total } = useCart();
  const { format } = useCurrency();

  return (
    <div data-testid="cart-page" className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <p className="overline mb-3">Your bag</p>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.02] mb-12">Almost yours.</h1>

      {items.length === 0 ? (
        <div className="py-20 text-center">
          <p className="font-serif-display text-3xl mb-4">Nothing here yet.</p>
          <Link to="/shop" className="btn-primary">Shop the masks</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-8">
            <ul className="divide-y divide-lum-border">
              {items.map((i) => (
                <li key={i.key} className="flex gap-6 py-6">
                  <div className={`w-28 h-32 ${i.accent === 'blue' ? 'accent-blue-soft' : i.accent === 'green' ? 'accent-green-soft' : 'accent-orange-soft'} flex-shrink-0`}>
                    <img src={i.image} alt={i.name} className="w-full h-full object-contain p-3" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif-display text-2xl leading-tight">{i.name}</h3>
                    <p className="text-xs text-lum-muted mt-1">{i.pack_size === 'pack' ? `Pack of ${i.pack_count}` : 'Single sheet'} · {format(i.unit_price)} each</p>
                    <div className="mt-4 flex items-center gap-6">
                      <div className="flex items-center border border-lum-border">
                        <button onClick={() => updateQty(i.key, i.quantity - 1)} className="px-2 py-1"><Minus size={12} /></button>
                        <span className="px-3 text-sm">{i.quantity}</span>
                        <button onClick={() => updateQty(i.key, i.quantity + 1)} className="px-2 py-1"><Plus size={12} /></button>
                      </div>
                      <button onClick={() => removeItem(i.key)} className="text-lum-muted hover:text-lum-text flex items-center gap-1 text-xs uppercase tracking-[0.2em]"><Trash2 size={14} /> Remove</button>
                    </div>
                  </div>
                  <p className="text-base">{format(i.unit_price * i.quantity)}</p>
                </li>
              ))}
            </ul>
          </div>

          <aside className="md:col-span-4 bg-lum-bg2 p-8 md:p-10 h-fit">
            <p className="overline mb-5">Order summary</p>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between"><span className="text-lum-text2">Subtotal</span><span>{format(subtotal)}</span></div>
              {bundleDiscount > 0 && <div className="flex justify-between text-lum-sale"><span>Bundle (10%)</span><span>−{format(bundleDiscount)}</span></div>}
              <div className="flex justify-between"><span className="text-lum-text2">Shipping</span><span>{shipping === 0 ? 'Free' : format(shipping)}</span></div>
              <div className="border-t border-lum-border pt-3 mt-3 flex justify-between text-base"><span>Total</span><span>{format(total)}</span></div>
            </div>
            <Link to="/checkout" data-testid="cart-checkout-button" className="btn-primary w-full mt-6">Proceed to checkout</Link>
            <Link to="/shop" className="btn-ghost block text-center mt-4">Continue shopping</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
